import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import CookieBanner from "./CookieBanner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#FDFCFB] text-[#111827]" style={{ fontFamily: "Manrope, system-ui, sans-serif" }}>
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
      <CookieBanner />
    </div>
  );
}
